import { Tags, Layers } from "lucide-react";
import { colors, fonts, SECTORS } from "../styles/theme";
import { useAuth } from "../hooks/useAuth";
import CurrencySection from "../features/settings/CurrencySection";
import SalesEmailSection from "../features/settings/SalesEmailSection";
import NewsletterSpacingSection from "../features/settings/NewsletterSpacingSection";
import QBOConnectionSection from "../features/settings/QBOConnectionSection";
import LinkedInConnectionSection from "../features/settings/LinkedInConnectionSection";
import YouTubeConnectionSection from "../features/settings/YouTubeConnectionSection";
import ContactTypeMappingSection from "../features/settings/ContactTypeMappingSection";
import ReReviewCyclesSection from "../features/settings/ReReviewCyclesSection";
import MasterListSection from "../features/settings/MasterListSection";
import EmailSyncSection from "../features/settings/EmailSyncSection";
import DataCleanupSection from "../features/settings/DataCleanupSection";
import RolePageAccessSection from "../features/settings/RolePageAccessSection";

export default function Settings() {
  const { role } = useAuth();
  return (
    <div>
      <h1
        style={{
          fontFamily: fonts.heading,
          fontSize: 28,
          fontWeight: 700,
          color: colors.text,
          marginBottom: 4,
        }}
      >
        Settings
      </h1>
      <p
        style={{
          fontFamily: fonts.body,
          fontSize: 14,
          color: colors.textSecondary,
          marginBottom: 32,
        }}
      >
        Configure your platform, integrations, and team access
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 20,
          maxWidth: 640,
        }}
      >
        {role === "admin" && <CurrencySection />}
        {role === "admin" && <SalesEmailSection />}
        {role === "admin" && <NewsletterSpacingSection />}
        {role === "admin" && <QBOConnectionSection />}
        {role === "admin" && <LinkedInConnectionSection />}
        {role === "admin" && <YouTubeConnectionSection />}
        {role === "admin" && <ContactTypeMappingSection />}
        {role === "admin" && <ReReviewCyclesSection />}
        {role === "admin" && (
          <MasterListSection
            title="Sectors"
            description="Master list of sectors available for company classification. Changes here update the dropdown on the Companies page."
            icon={Layers}
            settingsKey="sectors"
            defaults={SECTORS}
          />
        )}
        {role === "admin" && (
          <MasterListSection
            title="Company Tags"
            description="Pre-defined tags that can be applied at company level (e.g. Advisory, Partner). When applied, these tags are automatically added to all contacts in that company."
            icon={Tags}
            settingsKey="companyTags"
            defaults={["Advisory", "Partner", "Prospect", "VIP", "Former Client"]}
          />
        )}
        {role === "admin" && <EmailSyncSection />}
        {role === "admin" && <DataCleanupSection />}
        {role === "admin" && <RolePageAccessSection />}
      </div>
    </div>
  );
}
